import { render } from "./SponsorEdit.vue?vue&type=template&id=d8b853bc&ts=true"
import script from "./SponsorEdit.vue?vue&type=script&lang=ts"
export * from "./SponsorEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__